/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { lazy, Suspense, useEffect, useState } from "react";
import "@fontsource/poppins";
import "../src/App.css";
import { CookieSetting } from "cookiesetting-component";
import axios from "axios";
import Header from "./components/Header";
import Banner from "./components/Banner/Banner";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import jsonData from "./components/ai-branding.json"; 
import RecaptureMoments from "./components/RecaptureTheMoments/RecaptureTheMoments";
const Interior = lazy(() => import("./components/Interior/Interior.js"));
const Logo = lazy(() => import("./components/Logo Section/NewLogoSection"));
const ThankYou = lazy(() =>
  import("./components/ThankYou/Thankyou.js")
);
const SubscribeNotification = lazy(() => import("./components/SubscribeNotification/SubscribeForEventNotifications.js"));
const Combinedcarousel = lazy(() =>
  import("./components/CombinedCarousel/Combined.js")
);

const SocialMedia = lazy(() =>
  import("./components/PostSocial/PostSocial.js")
);
const Footer = lazy(() => import("./components/CommenFooterComponent/index"));

function App() {
  const [links, setLinks] = useState(null);
  const [showOtherComponents, setShowOtherComponents] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once, like componentDidMount


  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <CacheBuster
      currentVersion={appversion.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} //If not pass, nothing appears at the time of new version check.
      metaFileDirectory={process.env.PUBLIC_URL} //If public assets are hosted somewhere other than root on your server.
    >
      <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
        <>
          <div className="bodyContainer">
            <Header fetchpriority="high" />
            {links ? (
              <>
                <Banner fetchpriority="high" links={links} />
                <Suspense fallback={<div />}>
                  <RecaptureMoments />
                </Suspense>
                {showOtherComponents && (
                  <>
                <Suspense fallback={<div />}>
                  <Interior links={links}  />
                </Suspense>
                <Suspense fallback={<div />}>
                  < SocialMedia />
                </Suspense>
                <Suspense fallback={<div />}>
                  <Logo />
                </Suspense>
                <Suspense fallback={<div />}>
                  <ThankYou links={links} />
                </Suspense>
                <Suspense fallback={<div />}>
                  <SubscribeNotification />
                </Suspense>
                <Suspense fallback={<div />}>
                  <Combinedcarousel links={links} />
                </Suspense>
                <Suspense fallback={<div />}>
                  <Footer />
                </Suspense>
                </>
                )}
              </>
            ) : (
              <div>Loading...</div>
            )}
          </div>
        </>
    </CacheBuster>
  );
}

export default App;

